import { render, staticRenderFns } from "./ClientHeadingSettings.vue?vue&type=template&id=522d761b&scoped=true"
import script from "./ClientHeadingSettings.vue?vue&type=script&lang=ts"
export * from "./ClientHeadingSettings.vue?vue&type=script&lang=ts"
import style0 from "./ClientHeadingSettings.vue?vue&type=style&index=0&id=522d761b&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522d761b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('522d761b')) {
      api.createRecord('522d761b', component.options)
    } else {
      api.reload('522d761b', component.options)
    }
    module.hot.accept("./ClientHeadingSettings.vue?vue&type=template&id=522d761b&scoped=true", function () {
      api.rerender('522d761b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout-editor/ClientHeadingSettings.vue"
export default component.exports